import bcrypt from 'bcryptjs';

export const encryptPassword = async (plainPassword: string) => {
  try {
    const salt = await bcrypt.genSalt(10); // Gera o salt (recomendado 10 ou mais)
    const hashedPassword = await bcrypt.hash(plainPassword, salt); // Criptografa a senha
    return hashedPassword; // Retorna a senha criptografada
  } catch (error) {
    console.error('Erro ao criptografar a senha:', error);
    throw error; // Trata o erro se algo der errado
  }
};


export const comparePassword = async (plainPassword: string, hashedPassword: string) => {
  try {
    const isMatch = await bcrypt.compare(plainPassword, hashedPassword); // Compara as senhas
    return isMatch; // Retorna true se forem iguais, false caso contrário
  } catch (error) {
    console.error('Erro ao comparar as senhas:', error);
    throw error; // Lança um erro se algo der errado
  }
};






